const paths = {
    image: "https://payz365.com/controlpanel/assets/images",
    devBundleDomain: "",
    prodBundleDomain: "https://pgdashboard.s3-website-us-east-1.amazonaws.com/login/"
}

export default paths;